"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const clone_1 = tslib_1.__importDefault(require("lodash/clone"));
const addDefaultPropertiesForPeerGradable_1 = tslib_1.__importDefault(require("../helpers/addDefaultPropertiesForPeerGradable"));
const emptySubmission_1 = tslib_1.__importDefault(require("../helpers/emptySubmission"));
const baseZeroState_1 = tslib_1.__importDefault(require("./baseZeroState"));
function addDefaultsSpecificToAssignmentQuestion(content, assignmentQuestionState) {
    let updatedAssignmentQuestionState = clone_1.default(assignmentQuestionState);
    const submissions = [emptySubmission_1.default()];
    const defaultsSpecificToAssignmentQuestion = {
        submissions,
        reAttemptCount: 0,
        actualSubmit: false
    };
    updatedAssignmentQuestionState = Object.assign(updatedAssignmentQuestionState, defaultsSpecificToAssignmentQuestion);
    updatedAssignmentQuestionState = addDefaultPropertiesForPeerGradable_1.default(content, updatedAssignmentQuestionState);
    return updatedAssignmentQuestionState;
}
function assignmentQuestionZeroState(content, user) {
    try {
        const baseState = baseZeroState_1.default(content, user);
        let assignmentQuestionState = clone_1.default(baseState);
        assignmentQuestionState = addDefaultsSpecificToAssignmentQuestion(content, assignmentQuestionState);
        return assignmentQuestionState;
    }
    catch (error) {
        throw new Error('Error in assignmentQuestionZeroState ' + error);
    }
}
exports.default = assignmentQuestionZeroState;
//# sourceMappingURL=assignmentQuestionZeroState.js.map